<form [formGroup]="updateStoreForm" (ngSubmit)="submitUpdatedStore()">
  <app-store-form formControlName="store"></app-store-form>
  <div>
    <button
      gaEvent="edit_store"
      [disabled]="updateStoreForm.invalid || submitted"
      [class.spinner]="submitted"
      mat-raised-button
      color="primary"
    >
      {{ buttonLabel }}
    </button>
  </div>
</form>
